import {
  faEllipsisV,
  faSortDown,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Menu, MenuItem } from "@material-ui/core";
import { memo, useContext, useEffect, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { useTheme } from "react-jss";
import { fonts, getLastUsers, useAuth, useLocalStorage } from "../../../core";
import { BotContext } from "../../context/BotContext";

import classNames from "classnames";
import { isMobile } from "react-device-detect";
import { useMutation } from "react-query";
import { useHistory } from "react-router-dom";
import { UsersModal } from "../..";
import Exit from "../../../assets/images/exit.svg";
import TextSize from "../../../assets/images/text-size.svg";
import useStylesHeader from "../../atoms/headerStyle";
import Bot from "../../../assets/images/bot.svg";

const Header = memo(() => {
  const [show, setShow] = useState(false);
  const [showFonts, setShowFonts] = useState(false);
  const [users, setUsers] = useState([]);
  const handleClose = () => {
    setShow(false);
    !isMobile && inputRef.current.focus();
  };
  const handleShow = (imgsrc) => {
    setShow(true);
    setMenuPosition(null);
    mutateLastUsers();
  };
  const theme = useTheme();
  const styles = useStylesHeader({ theme });
  const {
    selectedRoom,
    rooms,
    setSelectedRoom,
    setChats,
    setChatsArray,
    setPage,
    fontSize,
    setFontSize,
    inputRef,
    setAskedQuestions,
    isAdmin,
    historyUser,
    setHistoryUser,
    setIsHistoryReady,
  } = useContext(BotContext);
  const { user, signout } = useAuth();
  const [, setRoom] = useLocalStorage("room");
  const history = useHistory();
  useEffect(() => {
    setChatsArray(undefined);
    setChats(undefined);
    setPage(1);
    setAskedQuestions([
      {
        question: "",
        label_question: "",
      },
    ]);
    !isMobile && inputRef.current.focus();
  }, [selectedRoom]);
  const [menuPosition, setMenuPosition] = useState(null);

  const toggleMenu = (event) => {
    if (menuPosition) {
      return;
    }
    setShowFonts(false);
    event.preventDefault();
    setMenuPosition({
      top: event.pageY,
      left: event.pageX,
    });
  };

  const changeFont = (font) => {
    setMenuPosition(null);
    setFontSize(font);
    !isMobile && inputRef.current.focus();
  };

  const toggleFontsMenu = () => {
    setShowFonts((prev) => !prev);
  };

  const { mutate: mutateLastUsers, isLoading } = useMutation(
    ["getLastUsers", show],
    async () => {
      if (selectedRoom) {
        const { data } = await getLastUsers({
          chat_room_name: selectedRoom.name,
        });
        setUsers(data.data.users);
        return data;
      }
    },
    {
      refetchOnMount: false,
      enabled: isAdmin && show,
    }
  );
  const isGuest = user?.cellnum && user?.cellnum === "guest_technoland";
  return (
    <div className={styles.headerRoom} id="header">
      <div onClick={toggleMenu} className={styles.toggleHeaderDots}>
        <FontAwesomeIcon
          icon={faEllipsisV}
          color={theme.headerDotColor}
          size="xl"
          id="threeDots"
        />
        <Menu
          className={classNames(styles.nestedMenu, styles.menu)}
          open={!!menuPosition}
          onClose={() => setMenuPosition(null)}
          anchorReference="anchorPosition"
          anchorPosition={menuPosition}
        >
          {isAdmin && <MenuItem onClick={handleShow}>تاریخچه کاربران</MenuItem>}
          <MenuItem className={styles.fontsMenuItem} onClick={toggleFontsMenu}>
            <div className={styles.fontsContent}>
              <div className={styles.fontsToggleBox}>
                <div>
                  <img
                    alt="sizing"
                    src={TextSize}
                    className={styles.menuIcon}
                  />
                  تنظیم سایز متن
                </div>
                <FontAwesomeIcon icon={faSortDown} color="#3A3F49" />
              </div>
              {showFonts && (
                <div className={styles.fontsBox}>
                  {fonts.map((font, index) => (
                    <span
                      key={index}
                      onClick={() => {
                        changeFont(font.value);
                      }}
                      className={
                        fontSize === font.value ||
                        (!fontSize && font.value === "16px")
                          ? styles.selectedFont
                          : ""
                      }
                    >
                      {font.label}
                    </span>
                  ))}
                </div>
              )}
            </div>
          </MenuItem>
          {user.refreshToken && !isGuest && (
            <MenuItem onClick={() => signout(history)}>
              <img alt="exit" src={Exit} className={styles.menuIcon} />
              خروج
            </MenuItem>
          )}
        </Menu>
      </div>
      {historyUser && (
        <div
          className={classNames(styles.toggleHeader, "btn")}
          onClick={handleShow}
        >
          <FontAwesomeIcon
            icon={faTimes}
            className={styles.dropdownIcon}
            onClick={() => setHistoryUser(undefined)}
          />

          <span>{historyUser?.fullname}</span>
        </div>
      )}
      {rooms?.length > 1 ? (
        <Dropdown align="end">
          <Dropdown.Toggle
            id="dropdown-button-dark-example1"
            variant="secondary"
            className={styles.toggleHeader}
          >
            <FontAwesomeIcon
              icon={faSortDown}
              className={styles.dropdownIcon}
              color="white"
            />
            <span>{selectedRoom?.descr}</span>
          </Dropdown.Toggle>

          <Dropdown.Menu
            variant=""
            className={styles.roomsMenu}
            style={{ maxHeight: "calc(100vh - 200px)", overflow: "auto" }}
          >
            {rooms?.map((room, index) => (
              <Dropdown.Item
                key={index}
                onClick={() => {
                  setIsHistoryReady(false);
                  setSelectedRoom(room);
                  setRoom(room);
                }}
                className={styles.roomItem}
              >
                {room.descr}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      ) : (
        <div className={styles.singleRoomHeader}>
          <span>پاسخگویی هوشمند</span>
          <img alt="bot" src={Bot} />
        </div>
      )}
      <UsersModal {...{ show, handleShow, handleClose, users, isLoading }} />
    </div>
  );
});
export { Header };
